import React, { useEffect, useState } from "react";
import { Container, Card, Row, Col, Button, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ApiConfig from "../../api/ApiConfig";
import { simplePostCall } from "../../api/ApiServices";
import ConfirmModal from "../../components/ConfirmModal";

export default function IncomeDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [income, setIncome] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  /* ---------------- FETCH INCOME ---------------- */
  useEffect(() => {
    fetchIncomeDetails();
  }, [id]);


  
  const fetchIncomeDetails = async () => {
    setLoading(true);

    const body = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const res = await simplePostCall(
        ApiConfig.incomeView,
        JSON.stringify(body)
      );

      if (res?.result && res?.data?.length > 0) {
        setIncome(res.data[0]);
      } else {
        toast.error("Income not found");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- DELETE ---------------- */
  const handleDelete = async () => {
    setIsDeleting(true);

    const body = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const res = await simplePostCall(
        ApiConfig.incomeDelete,
        JSON.stringify(body)
      );

      if (res?.result) {
        toast.success(res.message);
        navigate("/accountant/OtherIncomes");
      } else {
        toast.error(res?.message || "Delete failed");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <Container fluid className="py-4">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* HEADER */}
      <Card className="mb-3" style={{backgroundColor:'#fff'}}>
        <Card.Body className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Income Details</h5>
          <div className="d-flex gap-2">
            <Button
            style={{backgroundColor: "#5db2e8"}}
              size="sm"
             
              onClick={() => navigate(`/accountant/EditIncome/${id}`)}
            >
              Edit
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => setShowDeleteModal(true)}
            >
              Delete
            </Button>
          </div>
        </Card.Body>
      </Card>

      {/* CONTENT */}
      <Card style={{backgroundColor:'#fff'}}>
        <Card.Body>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : !income ? (
            <div className="text-center">No data found</div>
          ) : (
            <>
              <Row className="mb-3 border-bottom pb-2">
                <Col md={4} className="fw-bold">
                  Bank Account Name
                </Col>
                <Col md={8}>
                  {income.bank_name}
                </Col>
              </Row>

              <Row className="mb-3 border-bottom pb-2">
                <Col md={4} className="fw-bold">
                  Income Name
                </Col>
                <Col md={8}>
                  {income.income_name}
                </Col>
              </Row>

              <Row className="mb-3 border-bottom pb-2">
                <Col md={4} className="fw-bold">
                  Date
                </Col>
                <Col md={8}>
                  {income.income_date_formatted}
                </Col>
              </Row>

              <Row className="mb-3 border-bottom pb-2">
                <Col md={4} className="fw-bold">
                  Description
                </Col>
                <Col md={8}>
                  {income.income_description || "-"}
                </Col>
              </Row>

              <Row>
                <Col md={4} className="fw-bold">
                  Amount
                </Col>
                <Col md={8}>
                  $ {income.income_amount}
                </Col>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>

      {/* DELETE CONFIRM */}
      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        title="Delete Income"
        message="Are you sure you want to delete this income record?"
        confirmText="Delete"
        confirmVariant="danger"
        onConfirm={handleDelete}
        isLoading={isDeleting}
      />
    </Container>
  );
}
